import { render, staticRenderFns } from "./NullData.vue?vue&type=template&id=180639d5&scoped=true"
import script from "./NullData.vue?vue&type=script&lang=js"
export * from "./NullData.vue?vue&type=script&lang=js"
import style0 from "./NullData.vue?vue&type=style&index=0&id=180639d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180639d5",
  null
  
)

export default component.exports